export default "__VITE_ASSET__ceb736ed__"